import OfflineDetector from "@/components/organisms/offline/OfflineDetector";
import { AuthenticationView } from "@/components/pages/authentication";
import { HomeView } from "@/components/pages/home";
import { useAuth } from "@/hooks/authentication";
import MessageOutlet from "../messages/outlet";

export const Router = () => {
	const authContext = useAuth();

	if (authContext.isInProgress) {
		return null; // can be loading view after reload
	}

	return (
		<>
			<MessageOutlet namespace="global" />
			<OfflineDetector />
			{authContext.isLogged ? <HomeView /> : <AuthenticationView />}
		</>
	);
};
